import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      position="top-right"
      offset="80px"
      className="toaster group"
      style={{ zIndex: 9999 }}
      toastOptions={{
        className: 'bg-transparent border-0 shadow-none p-0',
      }}
      {...props}
    />
  );
};

export { Toaster };
